import { AbstractCollectionDirective } from './abstract-collection.directive';
import { Component } from '@angular/core';

@Component({
  templateUrl: './verisk-detail.component.html',
  styleUrls: ['./ie11-fixes.scss'],
})
export class VeriskDetailComponent extends AbstractCollectionDirective {}
